module.exports = __webpack_public_path__ + "static/interior-demolition-302ebafe00686a45d2845aa8d07911f1.jpg";